module["exports"] = [
  "England",
  "Scotland",
  "Wales",
  "Northern Ireland"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_GB/address/uk_country.js
// module id = 792
// module chunks = 0